var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSanyaLine(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 199,
    height: 5,
    viewBox: "0 0 199 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.588 3.46645C158.456 1.56257 118.641 2.09114 79.3992 1.47358C53.4506 1.06301 27.5025 0.386037 1.57239 0.0122304C0.794965 0.00152871 0.153261 0.264478 0.139582 0.601937C0.126373 0.9394 0.746539 1.22127 1.5235 1.23197C27.4508 1.60575 53.3961 2.2827 79.3418 2.69324C118.513 3.3102 158.253 2.77895 197.314 4.6802C198.089 4.71731 198.776 4.47712 198.854 4.14225C198.928 3.80733 198.357 3.50555 197.588 3.46645Z",
    fill: "#DAB7D8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSanyaLine);
export default __webpack_public_path__ + "static/media/sanyaLine.bc2cf53c3d1168f3c76b0bebffd5a32c.svg";
export { ForwardRef as ReactComponent };